<template lang="pug">
vm-row( class="details" vm-w="12")
  vm-col(class="details__titles" vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
    div
      h2 {{ $t('strings.requisition') }}
    div(class="details__titles__subtitles")
      h4 {{ requisition.project.name }}
      span {{ requisition.folio }}
  vm-row(vm-w="12")
    vm-col.card(vm-sm=12)
      vm-table(multiple v-model="selected" max-items="10" pagination  max-height="350px" :data="form.details" )
        template(slot="header")
          h4 {{ $t('requisitions_mailboxes.filter') }}
          vm-input(class="details__search" ref="search" icon="search" v-model="searchParam" @keyup.enter="onSearch" width="100%")
        template(slot="thead")
          vm-th(:key="index" v-for="(column, index) in columns") {{ $t('requisitions_mailboxes.' + column) }}
        template(slot-scope="{data}")
          vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
            vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
              slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
              slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
              slot(v-if="column == 'supply'")  {{ data[indextr][column]['sku'] }}
              slot(v-if="column == 'supply_order_quantity'")  {{ data[indextr][column] }}
              vm-input(:disabled="data[indextr].supply_pending_quantity === 0" v-if="column == 'supply_pending_quantity'" v-model="data[indextr].supply_pending_quantity")
              slot(v-if="column != 'status' && column != 'supply_pending_quantity' && column != 'supply_order_quantity' && column != 'remaining' && column != 'supply' && column != 'created_at' && column != 'name' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
      transition(name="enter")
        .total-products(v-if="total>0") Total de productos: {{ requisition.product_amount }}
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Requisitions')
export default {
  name: 'DetailsRequisition',
  components: {},
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['id', 'supply', 'supply_unit', 'supply_amount', 'supply_order_quantity', 'supply_pending_quantity'],
    form: {},
    total: 8,
    searchParam: ''
  }),
  computed: {
    ...mapGetters(['requisition', 'suppliesShipped'])
  },
  watch: {
    selected (datas) {
      this.$emit('onSelected', datas)
    }
  },
  async created () {
    await this.loadRequisition({ id: this.$route.params.id }).then(() => {
      this.form = { ...this.requisition }
      this.setLoaderVisible(false)
    })
  },
  methods: {
    ...mapActions([
      'loadRequisition',
      'setLoaderVisible',
      'addSuppliesShipped',
      'setSuppliesShipped'
    ]),
    onSearch () {
      this.searchParam ? this.form.details = Array(...this.requisition.details.filter(detail => detail.supply.sku.toLowerCase().includes(this.searchParam.toLowerCase()))) : this.form = { ...this.requisition }
    }
  }
}
</script>
<style lang="scss">
.details {
  &__titles {
    flex-direction: column;
    align-items: initial !important;
    &__subtitles {
       display: flex;
      flex-direction: row;
      h4 {
        font-size: 16px;
      }
      span {
        font-size: 16px;
        margin-left: 5px;
        font-weight: 400;
        color: #9EA5AB;
      }
    }
  }
  .card {
    margin-top: 10px;
    border: 1px solid rgba($color: var(--gray), $alpha: 1.0);
    padding: 20px !important;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
    header {
      span {
        width: 100%;
        .vm-con-input-label {
          margin: 10px 0;
        }
      }
    }
  }
  &__details__search {
    border: 1px solid rgba($color: var(--gray), $alpha: 1.0);
    border-radius: 10px;
    margin: 10px 0;
  }
  .total-products {
    font-weight: 600;
    font-size: 12px;
  }
}
</style>
